export const API_EXTERNAL_ENDPOINT = 'branding-campaign'

export const API_INTERNAL_ENDPOINT = 'strapi/branding-campaign'
